import classnames from 'classnames';
import React__default from 'react';
import { getDisplayColumns } from '../utils/columnUtils.js';
import { useTable } from '../utils/hooks.js';

/**
 * NoRowData - Renders when there is no row data
 * @returns {any}
 */

function NoRowData() {
  var _useTable = useTable(),
    _useTable$state = _useTable.state,
    columns = _useTable$state.columns,
    dataTestId = _useTable$state.dataTestId,
    groupDisplayType = _useTable$state.groupDisplayType,
    showGrid = _useTable$state.showGrid;
  var classesForAllBodyCell = classnames('C-TableAdvanced__bodyCell', {
    '--showGrid': showGrid
  }, 'hc-ta-center');
  var displayColumns = getDisplayColumns(columns.columnDefs, groupDisplayType);
  return /*#__PURE__*/React__default.createElement("tr", {
    className: "C-TableAdvanced__bodyRow",
    key: 'noRowData',
    "data-testid": dataTestId ? "".concat(dataTestId, "-noRowData") : null
  }, /*#__PURE__*/React__default.createElement("td", {
    colSpan: displayColumns.length,
    className: classesForAllBodyCell,
    key: "no-data"
  }, "This table has no data to display"));
}

export { NoRowData as default };
